import { container } from "tsyringe";

import * as CoreFrameDTOs from "coreframetypings/dto";

export interface IResourceManager {
    resources: KnockoutObservable<{}>;
    language: { data?: KnockoutObservableArray<any>, value?: KnockoutComputed<string> };
    currentLoadedLang: string;
    MLSTRING_SEPARATOR: string;

    /**
     * Liefert das DTO der aktuell ausgewählten Sprache
     * oder des übergebenen ISO-Codes
     * @returns {LanguageDTO|null} Das Language-DTO der ausgewählten Sprache oder null
     */
    getLanguage(languageIso?: string): CoreFrameDTOs.ILanguageDTO;

    /**
     * Retrieves a resource based on the given ergName.
     * If the resource is not found, the ergName itself will be returned.
     *
     * @param {string} ergName - The name of the resource to retrieve.
     * @return {string} - The retrieved resource or the ergName if not found.
     */
    get(ergName: string): string;

    /**
     * Load a resource from the this.
     *
     * @param {string} ergName - The name of the resource.
     * @param {boolean} [tryToLoad] - Flag indicating whether to try loading the resource if not found. Default value is false.
     * @return {JQueryPromise<string> | string} - The loaded resource or ergName if not found.
     */
    loadResource(ergName: string, tryToLoad?: boolean): JQueryPromise<string> | string;

    /**
     * Requests a resource item from the server.
     *
     * @param {string} ergName - The name of the resource to request.
     * @return {JQueryPromise<string>} - A promise that resolves to the requested resource.
     */
    requestResourceItem(ergName: string): JQueryPromise<string>;

    setLanguage<T = true>(callback?: () => T): JQuery.Promise<T>;

    loadLanguageArtfacts(language: string): JQueryPromise<any>;

    getLanguagesForLogin(): any[];

    init(usableLanguageIso6391: string): JQueryPromise<any>;

    getTranslationInMLString(mlstring: string, language: string): string;

    /**
     * Converts a dictionary of translation to a MLString
     * @param translations
     */
    getMLStringFromTranslations(translations: Record<string, string>): string;
}

export default class ResourceManager {
    public static getInstance(): IResourceManager {
        return container.resolve<IResourceManager>("ResourceManager");
    }
}